import React, { useState } from 'react';
import { Alert, Box, Button, CircularProgress, IconButton, InputAdornment, Snackbar, TextField } from '@mui/material';
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import LoginRoundedIcon from '@mui/icons-material/LoginRounded';
import AuthLayout from '../components/layout/AuthLayout';
import { API_URL } from '../api';

const SignInPage = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const email = state?.email || '';
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [notice, setNotice] = useState({ open:false, message:'', severity:'error' });
  if (!email) return <Navigate to="/login" replace />;

  const signIn = async (event) => {
    event.preventDefault();
    if (!password) { setNotice({ open:true, message:'Enter your password.', severity:'error' }); return; }
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/v1/users/signin`, { method:'POST', headers:{ 'Content-Type':'application/json' }, body:JSON.stringify({ email, password }) });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.message || 'That password did not match. Please try again.');
      localStorage.setItem('token', data.token); localStorage.setItem('role', data.role || 'USER'); localStorage.setItem('userId', String(data.userId));
      navigate('/', { replace:true, state:{ user:data } });
    } catch (error) { setNotice({ open:true, message:error.message, severity:'error' }); }
    finally { setLoading(false); }
  };

  return <AuthLayout eyebrow="Welcome back" title="Sign in to your account" description={<>Continue as <Box component="strong" sx={{ color:'text.primary' }}>{email}</Box></>}>
    <Box component="form" onSubmit={signIn}><TextField autoFocus fullWidth label="Password" type={showPassword ? 'text' : 'password'} value={password} onChange={(event) => setPassword(event.target.value)} InputProps={{ endAdornment:<InputAdornment position="end"><IconButton onClick={() => setShowPassword((value) => !value)} edge="end" aria-label={showPassword ? 'Hide password' : 'Show password'}>{showPassword ? <VisibilityOffOutlinedIcon /> : <VisibilityOutlinedIcon />}</IconButton></InputAdornment> }} sx={{ mb:2 }} /><Button fullWidth type="submit" variant="contained" size="large" disabled={loading} endIcon={loading ? <CircularProgress size={18} color="inherit" /> : <LoginRoundedIcon />}>Sign in</Button></Box>
    <Box sx={{ mt:3, display:'flex', justifyContent:'space-between', flexWrap:'wrap', gap:1 }}><Button component={Link} to="/login" size="small">Use another email</Button><Button component={Link} to="/forgot-password" size="small">Forgot password?</Button></Box>
    <Snackbar open={notice.open} autoHideDuration={5000} onClose={() => setNotice((value) => ({ ...value, open:false }))} anchorOrigin={{ vertical:'top', horizontal:'center' }}><Alert severity={notice.severity}>{notice.message}</Alert></Snackbar>
  </AuthLayout>;
};
export default SignInPage;
